import api from './';

export default {
  getWorkers() {
    return api.post('Workers/GetList', {}).then(response => response.data);
  },
  getAllActiveWorkers() {
    return api.post('Workers/GetAllActiveList', {}).then(response => response.data);
  },
  getAllWorkers() {
    return api.post('Workers/GetAllList', {}).then(response => response.data);
  },
  getWorker(arg) {
    return api.post('Workers/Get', { workerGuid: arg }).then(response => response.data);
  },

  saveWorker(arg) {
    return api.post('Workers/Save', { worker: arg }).then(response => response.data);
  },

  searchWorker(arg) {
    return api.post('Workers/Search', { search: arg }).then(response => response.data);
  },

  deleteWorker(arg) {
    return api
      .post('Workers/Delete', { workerGuid: arg })
      .then(response => response.data);
  },
};
